<template>
	<dms-wrapper :label="labelText" :show-label="!isHiddenLabel" v-bind="{span, wrapp: true}" disabled>
		<div class="el-input el-input--mini is-disabled input-label">
			<div class="el-input__inner">
				{{ value }}
				<template v-if="value !== null && suffixText">
					{{ suffixText }}
				</template>
			</div>
		</div>
	</dms-wrapper>
</template>

<script>
import DmsWrapper from '#components/dms/form/Wrapper.vue';
import { DmsBaseComponent } from '#components/dms/common/base';

export default DmsBaseComponent.extend({
	name: 'DmsInputShow',
	components: { DmsWrapper },
	props: {
		value: { type: [String, Number] },
		suffixText: { type: String, default: '' },
	},
});
</script>
